import StimulusTomSelect from "stimulus-tom-select";

export default class extends StimulusTomSelect {
    initTomSelect() {
        this.options = {
            allowEmptyOption: true,
            ...this.optionsValue,
        };
        super.initTomSelect();
    }
}
